import { Button } from '@/Components/ui/button'
import { Spinner } from '@/Components/ui/spinner'
import logo from '@/imgs/logo.png'

interface LoadingScreenProps {
  onRefresh?: () => void
}
export function LoadingScreen({ onRefresh }: LoadingScreenProps) {
  return (
    <div dir='rtl' className='bg-background-app flex min-h-dvh w-full items-center justify-center p-6'>
      <div className='m-auto flex h-[600px] w-[300px] flex-col items-center justify-between gap-6'>
        <img src={logo} alt='logo' className='h-auto w-48' />
        <div className='flex flex-col items-center gap-4'>
          <Spinner className='h-12 w-12' />
          <p className='text-lg font-medium text-gray-900'>טוען...</p>
        </div>
        {onRefresh && (
          <Button onClick={onRefresh} variant='default' size='lg'>
            חזרה לעמוד הבית
          </Button>
        )}
      </div>
    </div>
  )
}
